export default {
    contacts: {}
}
